// extracted by mini-css-extract-plugin
export default {"outer":"styles_outer__+tq5x","vertical":"styles_vertical__bls2E","inner":"styles_inner__2tpVk","horizontal":"styles_horizontal__0ATzw"};